import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-content"
};
const _hoisted_2 = {
  class: "content"
};
import { ref, onMounted, toRefs, watch } from 'vue';
import DialogHeader from '@/components/dialog-header/index.vue';
import GlobalSearch from './global-search.vue';
import BatchOperation from '@/components/mct-header/batch-operation/index.vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'search-dialog',
  props: {
    visible: {
      type: Boolean
    },
    activeTab: {},
    searchValue: {}
  },
  emits: ["confirm", "update:visible"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const {
      visible,
      activeTab,
      searchValue
    } = toRefs(props);
    const activeName = ref(activeTab.value);
    const searchedValue = ref(searchValue.value);
    const resetSearchValue = data => {
      searchedValue.value = data;
    };
    const emits = __emit;
    const dialogVisible = ref(false);
    const handleBeforeClose = () => {
      emits('update:visible', false);
    };
    onMounted(() => {
      dialogVisible.value = visible.value;
    });
    watch(() => visible.value, () => {
      dialogVisible.value = visible.value;
      if (!dialogVisible.value) {
        activeName.value = '';
      } else {
        searchedValue.value = searchValue.value;
        activeName.value = activeTab.value;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => dialogVisible.value = $event),
        "show-close": false,
        width: "90%",
        "before-close": handleBeforeClose
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": "",
          "guide-link": "/docs/keyFunction/advancedSearchAndOperation.html"
        }, null, 8, ["onClose"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_tabs, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          class: "search-tabs"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
            label: "Search",
            name: "GLOBAL_SEARCH"
          }), _createVNode(_component_el_tab_pane, {
            label: "Advanced Search and Operation",
            name: "BATCH_OPERATION"
          })]),
          _: 1
        }, 8, ["modelValue"]), activeName.value === 'GLOBAL_SEARCH' ? (_openBlock(), _createBlock(GlobalSearch, {
          key: 0,
          "search-value": searchedValue.value,
          onResetSearchValue: resetSearchValue
        }, null, 8, ["search-value"])) : _createCommentVNode("", true), activeName.value === 'BATCH_OPERATION' ? (_openBlock(), _createBlock(BatchOperation, {
          key: 1,
          "search-value": searchedValue.value,
          onResetSearchValue: resetSearchValue
        }, null, 8, ["search-value"])) : _createCommentVNode("", true)])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});